import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c21fd22"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dashboard-summary-grid"
}
const _hoisted_2 = { class: "dashboard-summary-grid__label" }

import { computed } from 'vue';
import DashboardWidget from '@/components/dashboard/DashboardWidget.vue';
import { useDashboardQuery } from '@/core/hooks/useDashboardQuery';
import { useDashboardStore } from '@/core/hooks/useDashboardStore';
import { DashboardService } from '@/core/services/Dashboard.service';
import {
  DASHBOARD_SEVERITY_VALUE_COLORS,
  DASHBOARD_SYSTEM_SUMMARY_KEYS,
} from '@/core/constants/dashboard.constants';
import type {
  DashboardSummaryMetric,
  DashboardSystemSummaryData,
} from '@/core/interfaces/Dashboard';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSummaryGrid',
  props: {
    compact: { type: Boolean }
  },
  setup(__props: any) {



const { scope } = useDashboardStore();

const {
  data,
  isFetching,
  isError,
  isEmpty,
  isStale,
  generatedAt,
  refetch,
} = useDashboardQuery<DashboardSystemSummaryData>(
  'system-summary',
  scope,
  (s) => DashboardService.getSystemSummary(s)
);

const gridItems = computed<DashboardSummaryMetric[]>(() => {
  if (!data.value?.items?.length) {
    return [];
  }

  const itemsByKey = new Map(
    data.value.items.map((item) => [item.key, item])
  );

  return DASHBOARD_SYSTEM_SUMMARY_KEYS.map((key) => itemsByKey.get(key)).filter(
    (item): item is DashboardSummaryMetric => Boolean(item)
  );
});

function valueColor(severity: string): string {
  return (
    DASHBOARD_SEVERITY_VALUE_COLORS[severity] ??
    DASHBOARD_SEVERITY_VALUE_COLORS.default
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardWidget, {
    title: "Tổng quan hệ thống",
    compact: _ctx.compact,
    loading: _unref(isFetching),
    error: _unref(isError),
    empty: _unref(isEmpty),
    "is-stale": _unref(isStale),
    "generated-at": _unref(generatedAt),
    "has-cached-content": Boolean(_unref(data)),
    "empty-text": "Chưa có dữ liệu tổng quan hệ thống.",
    onRetry: _unref(refetch)
  }, {
    default: _withCtx(() => [
      (gridItems.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gridItems.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.key,
                class: "dashboard-summary-grid__item"
              }, [
                _createElementVNode("div", {
                  class: "dashboard-summary-grid__value",
                  style: _normalizeStyle({ color: valueColor(item.severity) })
                }, _toDisplayString(item.formattedValue), 5),
                _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["compact", "loading", "error", "empty", "is-stale", "generated-at", "has-cached-content", "onRetry"]))
}
}

})